/**
 * Cómo se muestra el estado de un CFDI. La cancelación ante el SAT va en dos pasos: se
 * solicita y, si el receptor debe aceptarla, puede tardar 3 días hábiles; si la rechaza la
 * factura sigue vigente. Antes todo se mostraba como "cancelada" al instante.
 */

export type EstadoVisibleFactura =
  | 'Borrador'
  | 'Timbrada'
  | 'CancelacionEnProceso'
  | 'CancelacionRechazada'
  | 'Cancelada';

const esPendiente = (estatus?: string) =>
  !!estatus && ['en proceso', 'pendiente'].includes(estatus.trim().toLowerCase());

const esRechazada = (estatus?: string) =>
  !!estatus && estatus.trim().toLowerCase().startsWith('solicitud rechazada');

/**
 * Estado visible a partir de lo que devuelve el Facturador (estado + estatusCancelacion) o
 * de la copia local de la orden (FacturaEstado, que ya puede traer "CancelacionEnProceso").
 */
export const estadoVisibleFactura = (estado?: string, estatusCancelacion?: string): EstadoVisibleFactura => {
  if (estado === 'Cancelada') return 'Cancelada';
  if (estado === 'CancelacionEnProceso') return 'CancelacionEnProceso';
  if (estado === 'Timbrada') {
    if (esPendiente(estatusCancelacion)) return 'CancelacionEnProceso';
    if (esRechazada(estatusCancelacion)) return 'CancelacionRechazada';
    return 'Timbrada';
  }
  return 'Borrador';
};

export const ETIQUETA_ESTADO_FACTURA: Record<EstadoVisibleFactura, { texto: string; color: string }> = {
  Borrador: { texto: 'Borrador', color: 'default' },
  Timbrada: { texto: 'Timbrada', color: 'success' },
  CancelacionEnProceso: { texto: 'Cancelación en proceso', color: 'warning' },
  CancelacionRechazada: { texto: 'Cancelación rechazada', color: 'processing' },
  Cancelada: { texto: 'Cancelada', color: 'error' },
};

/** ¿Tiene una solicitud de cancelación sin resolver? */
export const cancelacionPendiente = (estado?: string, estatusCancelacion?: string) =>
  estadoVisibleFactura(estado, estatusCancelacion) === 'CancelacionEnProceso';
